const ACTIVITIES_HEADERS = [
  {
    label: "Status",
    id: "status",
    name: "Status",
    sort: 0,
    value: null
  },
  {
    label: "Name",
    id: "name",
    name: "Name",
    sort: 0,
    value: null
  },
  {
    label: "Assigned Tags",
    id: "tags",
    name: "Assigned Tags",
    sort: 0,
    value: null
  },
  {
    label: "Company/Opportunity",
    id: "companies",
    name: "Company/Opportunity",
    sort: 0,
    value: null
  },
  {
    label: "Contacts",
    id: "contacts",
    name: "Contacts",
    sort: 0,
    value: null
  },
  {
    label: "Team Members",
    id: "collaborators",
    name: "Team Members",
    sort: 0,
    value: null
  },
  {
    label: "Start Date",
    id: "start_date",
    name: "Start Date",
    sort: 0,
    value: null
  },
  {
    label: "Due Date",
    id: "date",
    name: "Due Date",
    sort: 0,
    value: null
  }
]
const PLAN_HEADERS = ACTIVITIES_HEADERS
const TASKS_HEADERS = ACTIVITIES_HEADERS
const GOAL_HEADERS = ACTIVITIES_HEADERS
const INTERACTIONS_HEADERS = [
  {
    label: "Type",
    id: "type",
    name: "Type",
    sort: 0,
    value: null
  },
  {
    label: "Category",
    id: "category",
    name: "Category",
    sort: 0,
    value: null
  },
  {
    label: "Assigned Tags",
    id: "tags",
    name: "Assigned Tags",
    sort: 0,
    value: null
  },
  {
    label: "Company/Opportunity",
    id: "companies",
    name: "Company/Opportunity",
    sort: 0,
    value: null
  },
  {
    label: "Contacts",
    id: "contacts",
    name: "Contacts",
    sort: 0,
    value: null
  },
  {
    label: "Team Members",
    id: "collaborators",
    name: "Team Members",
    sort: 0,
    value: null
  },
  {
    label: "Date",
    id: "date",
    name: "Date",
    sort: 0,
    value: null
  }
]

export { ACTIVITIES_HEADERS, INTERACTIONS_HEADERS, PLAN_HEADERS, TASKS_HEADERS, GOAL_HEADERS }
